import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { DEVICE } from '../../../../../shared/domain/tokens/device.token';
import { BOOKING_REPOSITORY } from '../../domain/tokens/booking.tokens';

@Injectable({ providedIn: 'root' })
export class LockBookingUseCase {
  private readonly bookingRepository = inject(BOOKING_REPOSITORY);
  private readonly deviceService = inject(DEVICE);

  execute(bookingId: string): Observable<{ locked: boolean; deviceName?: string }> {
    const localDeviceName = this.deviceService.getDeviceInfo()?.name;

    if (!localDeviceName) {
      return of({ locked: true });
    }

    return this.bookingRepository.checkStatus(bookingId).pipe(
      map(({ deviceName }) => ({
        locked: !!deviceName && deviceName !== localDeviceName,
        deviceName
      })),
      catchError(() => of({ locked: true }))
    );
  }
}
